import React from 'react';

////////////// TODO
////////////// abstract out logic for generating filter dropdowns
var headerTest;

export let _generateTableColumns = (originalColumns, rowLookup, dataLength) => {
	try {
		let formattedColumns = [];

		formattedColumns = originalColumns.map(function(obj,index) {
			var newColumn = obj;

			var isCheckboxEnabled = obj.checkbox === true ? true : false;

			newColumn.Header = obj.sortable ? getSortableHeader(obj.Header) : obj.Header;

			if(isCheckboxEnabled && index === 0 && dataLength > 0)
			{
				newColumn = getCheckboxColumn(obj, rowLookup);
			}

			return newColumn;
		});

		return formattedColumns
	}
	catch(err) {
		throw err;
	}
};

export let getSortableHeader = (headerText) => {
	headerTest = headerText;
	if(typeof headerText.props == "undefined")
	{
		return (
				<span>
					<span>{headerText}</span>
					<span className="s-ico">
						<span sort="asc" className="ui-icon ui-icon-triangle-1-n"></span>
						<span sort="desc" className="ui-icon ui-icon-triangle-1-s"></span>
					</span>
				</span>
			)
	}
	else if(headerText.props.children[1].props.className.indexOf('s-ico') == -1)
		return (
			<span>
				<span>{headerText}</span>
				<span className="s-ico">
					<span sort="asc" className="ui-icon ui-icon-triangle-1-n"></span>
					<span sort="desc" className="ui-icon ui-icon-triangle-1-s"></span>
				</span>
			</span>
		)
	else
		return headerText;
};

export let getCheckboxColumn = (obj, rowLookup) => {
	var checkboxColumn = obj;
	var headerChecked = $.isEmptyObject(rowLookup) ? false : rowLookup.header.selected; 
	
	checkboxColumn.Header = <StyledCheckbox id={'grid_header_check_all_' + obj.id} checked={headerChecked}/>;

	checkboxColumn.Cell = (row => <StyledCheckbox id={'grid_check_' + row.original.ID} checked={
		rowLookup && rowLookup[row.original.ID] && rowLookup[row.original.ID].selected ? true : false} readOnly/>
		/* $.isEmptyObject(rowLookup) && $.isEmptyObject(rowLookup[row.original.ID]) ? false : rowLookup[row.original.ID].selected} readOnly/>*/
	);
	checkboxColumn.style = { textAlign: 'center' };
	checkboxColumn.width = typeof checkboxColumn.width != 'undefined' ? checkboxColumn.width : 65;

	return (checkboxColumn);
};

export let _generateCheckboxLookup = (data, rows, rowIDs, shouldLookupPersist) => {
	var lookup = {};
	var idArray = [];
	
	if(shouldLookupPersist)
	{		
		lookup = rows;
		idArray = rowIDs;
	}
	else {
		lookup['header'] = {
			ID: 'header',
			selected: false
		}

		data.forEach(function(obj) {
			lookup[obj.ID] = { 
				... obj,
				selected: false
			};

			idArray.push(obj.ID);
		});
	}

	var returnObject = { 
		idArray: idArray,
		lookup: lookup
	 }

	return returnObject;
}

export let _formalizeData = (dataArray) => {
	var newDataArray = dataArray.map(function(obj, index) {
		var newObj = jQuery.extend(true, {}, obj);

		newObj.Key = index;

		return newObj;
	})

	return newDataArray;
}


// WEBPACK FOOTER //
// ./src/table/table-helpers.js